import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'nprogress/nprogress.css'
require('@/store/subscriber')

axios.defaults.baseURL = "https://you-play.onrender.com/"

store.dispatch('attempt', localStorage.getItem('token')).then(() => {
  createApp(App).use(store).use(router).mount('#app')
})
